import '@low/inject-guard';
import guard from '@low/guard';
import { getPrefixedLogger, labels } from '@ringcentral/rwc-utils/src/rwc-logger';

guard().catch(e => getPrefixedLogger('vc:fork').error(labels.HANDLED_REJECTION, e));
